<template>
    <main class="vx-row">

        <div class="vx-col w-full p-8 rounded" style="background: #f7f7f7;height: 100vh;overflow: auto;">
            <section class="vx-row">

                <!-- Detail Qurban -->
                <div class="vx-col w-full md:w-2/3 mb-6 md:mb-0">
                    <vx-card>
                        <header class="mb-4">
                            <router-link class="flex items-center" :to="`/qurban/view/${this.$route.params.slug_and_id}`">
                                <feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
                                <strong class="block text-primary"><small>Kembali</small></strong>
                            </router-link>
                        </header>

                        <div class="mb-6">
                            <p class="mb-2"><strong>Lembaga Penyaluran</strong></p>
                            <v-select 
                v-model="mt"
                class="w-full"
                :options="mitra"
            />
                        </div>

                        <!-- <div class="mb-6">
                            <p class="mb-2"><strong>Pilih Kategori Hewan Qurban</strong></p>
                            <v-select 
                                v-model="category"
                                class="w-full"
                                :options="animalCategory"
                            />
                        </div> -->

                        <div class="mb-6">
                            <p class="mb-2"><strong>Harga Hewan Qurban</strong></p>
                            <h4 class="text-warning">

                                <strong>Rp {{ this.price == 0 ? 0 : formatRupiah(this.price) }}</strong>
                            </h4>
                        </div>

                        <section v-if="data.status == 1 && data.hewan && ['sapi', 'kerbau', 'unta'].includes(data.hewan.toLowerCase())">

                            <vs-divider></vs-divider>
                            <div class="vx-row items-center justify-between">
                                <div class="vx-col w-full md:w-2/3 lg:w-3/4">
                                    <p>Jumlah Mudhohi</p>
                                </div>
                                <div class="vx-col w-1/3 lg:w-1/4">
                                    <counter @count="count">
                                        <template #content>
                                            {{ mudhohis.length }}
                                        </template>
                                    </counter>
                                </div>
                            </div>
                            <vs-divider></vs-divider>
                        </section>
                        <div class="mb-6">
                            <p class="mb-2"><strong>Nama</strong></p>
                            <div
                                v-for="(item, i) in mudhohis"
                                :key="i"
                                class="mb-4"
                            >
                                <vs-input 
                                    placeholder="Fulan bin Fulan"
                                    v-model="item.value"
                                    class="rounded w-full"
                                />
                            </div>
                        </div>
                    </vx-card>
                </div>
                <!-- / -->

                <!-- Nominal Qurban -->
                <div class="vx-col w-full md:w-1/3">
                    <vx-card>
                        <p class="mb-6"><strong>Rincian Hewan Qurban</strong></p>
                        <div class="flex justify-between flex-col lg:flex-row mb-2" style="overflow: auto;">
                            <strong class="text-sm block text-grey">
                                <small>Qurban</small>
                            </strong>
                            <strong class="text-sm block text-dark w-full md:w-48 lg:text-right" >
                                <small>
                                    {{ qurban.name ? qurban.name : '-' }}
                                </small>
                            </strong>
                        </div>
                        <div class="flex justify-between flex-col lg:flex-row mb-2" style="overflow: auto;">
                            <strong class="text-sm block text-grey">
                                <small>Tipe Hewan</small>
                            </strong>
                            <strong class="text-sm block text-dark w-full md:w-24 lg:text-right" >
                                <small>
                                    {{ qurban.hewan ? capitalize(qurban.hewan) : '-' }}
                                </small>
                            </strong>
                        </div>
                        <div class="flex justify-between flex-col lg:flex-row mb-2" style="overflow: auto;">
                            <strong class="text-sm block text-grey">
                                <small>Berat</small>
                            </strong>
                            <strong class="text-sm block text-dark w-full md:w-24 lg:text-right" >
                                <small>
                                    {{ qurban.berat ? qurban.berat : '-' }}
                                </small>
                            </strong>
                        </div>
                        <div class="flex justify-between flex-col lg:flex-row mb-2" style="overflow: auto;">
                            <strong class="text-sm block text-grey">
                                <small> Jumlah Mudhohi</small>
                            </strong>
                            <strong class="text-sm block text-dark">
                                <small>
                                    {{ mudhohis.length }} orang
                                </small>
                            </strong>
                        </div>

                        <div class="flex justify-between flex-col lg:flex-row mb-2" style="overflow: auto;">
                            <strong class="text-sm block text-grey">
                                <small>Harga</small>
                            </strong>
                            <strong class="text-sm block text-dark">
                                <small>
                                    Rp {{ price == 0 ? 0 : formatRupiah(price) }}
                                </small>
                            </strong>
                        </div>
                        <vs-divider class="mb-4"></vs-divider>
                        <div class="flex justify-between flex-col lg:flex-row mb-6">
                            <strong class="text-sm block text-grey">
                                <small>Total</small>
                            </strong>
                            <strong class="text-sm block text-dark">
                                <small>
                                    Rp {{ price == 0 ? 0 : formatRupiah(price) }}
                                </small>
                            </strong>
                        </div>
                        <vs-button @click.prevent="saveData" rounded class="w-full md:p-2">
                            <small class="text-xs">Pilih Metode Pembayaran</small>
                        </vs-button>
                    </vx-card>
                </div>
                <!-- / -->
            </section>
        </div>
    </main>
</template>
<script>
    const sapiCode = 'sapi',
        sapiLimit = 7

    export default {
        components: {
            vSelect: () => import('vue-select'),
            Counter: () => import('@/views/components/Counter.vue')
        },
        watch: {
            sumMudhohi(val) {
                if(val < 1) {
                    return 1;
                }

                return val;
            }
        },
        methods: {
            saveData() {
                if( !this.mt ) {
                    this.$vs.notify({
                        title: 'Harap Pilih Lembaga Penyaluran',
                        text: '',
                        color: 'warning',
                        position: 'top-right'
                    });

                    return false;
                }

                if( this.mudhohis[0].value == '' || this.mudhohis[0].value == null ) {
                    this.$vs.notify({
                        title: 'Oops, Periksa Data Kembali',
                        text: 'Harap Isi Minimal 1 Nama Mudhohi',
                        color: 'warning',
                        position: 'top-right'
                    });

                    return false;
                }

                // if( this.mudhohis.some((item) => item.value == '' || item.value == null) ) {
                //     this.$vs.notify({
                //         title: 'Harap Isi Semua Nama Mudhohi',
                //         text: '',
                //         color: 'warning',
                //         position: 'top-right'
                //     });

                //     return false;
                // }

                this.data.mt = this.mt;
                this.data.price = this.price;
                this.data.category = this.category;
                this.data.mudhohis = this.mudhohis;

                this.$store.dispatch('qurban/setTransactionProduct', this.data);

                let link = `/qurban/choose-payment/${this.$route.params.slug_and_id}`;

                if(this.$route.query.ref) {
                    link += `?ref=${this.$route.query.ref}`;
                }

                this.$router.push(link);
            },
            getMitra() {
                const params = {
                    status: 1,
                    status_lembaga: 1
                }

                this.$store.dispatch('mitra/getChoiceMitra', params)
                .then(data => {
                    this.$vs.loading.close();
                    const mitra = data.data.slice();
                    mitra.map(item => item.label = item.user ? item.user.name : item.name);
                    this.mitra = mitra;

                    // Get selected mitra
                    if(this.$route.query.m) {
                        const selectedMitra = this.mitra.find(it => it.id == this.$route.query.m);
                        if(selectedMitra) {
                            this.mt = selectedMitra;
                        }
                    }
                    else {
                        // get id from slug
                        const ownerId = this.qurban.user ? this.qurban.user.id : 0;
                        
                        const selectedMitra = this.mitra.find(it => {
                            if(it.user) {
                                return it.user.id == ownerId;
                            }
                        });

                        if(selectedMitra) {
                            this.mt = selectedMitra;
                        }
                    }
                })
                .catch(e => {
                    this.$vs.loading.close();
                    this.showError(e);
                })
            },
            count(payload) {
                
                if(payload.ops == '-') {
                    this.mudhohis = this.mudhohis.splice(0, payload.val);
                }
                else {
                    if(this.mudhohis.length < sapiLimit) {
                        this.mudhohis.push({
                            value: null
                        });
                    }
                }
            },
            getQurban() {
                // get id from slug
                const arrSlug = this.$route.params.slug_and_id.split('-'),
                        id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

                // Check if exist in state
                this.$store.dispatch('qurban/getDetail', id)
                .then(qurban => {
                    this.qurban = qurban;
                    this.category = qurban.kat_id;
                    this.price = qurban.nominal;
                    Object.assign(this.data, qurban);
                    this.data.deskripsi = this.replaceText(this.data.deskripsi);
                    this.getMitra();
                })
                .catch(e => {
                    console.error(e);
                    // this.$router.push('/404-notfound')

                    return false;
                });
            }
        },
        data: () => ({
            data: {
                penerima_manfaat: []
            },
            isSapi: false,
            mitra: [],
            mudhohis: [
                {
                    value: null
                }
            ],
            sumMudhohi: 0,
            priceList: [
                {
                    id: 1,
                    label: '2.700.000'
                },
                {
                    id: 2,
                    label: '32.700.000'
                }
            ],
            animalCategory: [
                {
                    id: 1,
                    label: 'Sapi'
                },
                {
                    id: 2,
                    label: 'Domba'
                }
            ],
            mt: null,
            category: null,
            price: 0,
            qurban: {}
        }),
        created() {
            this.getQurban();
            if(this.profile) {
                this.mudhohis[0].value = this.profile.name;
            }

            // Jika qurban adalah sapi dan full (bukan 1/7) maka default mudhohi 7
            if( 
                this.qurban.hewan &&
                this.qurban.hewan.toLowerCase() == sapiCode &&
                this.qurban.status == 1
            ) {
                for(let i = 0;i < 5;i++) {
                    this.mudhohis.push({ value: null });
                }
            }
        }
    };
</script>